var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('van-overlay',{staticClass:"overlayStyle",attrs:{"slot":"overlay","show":_vm.isShow},slot:"overlay"},[_c('img',{staticClass:"imgStyle",attrs:{"src":_vm.loadingImg}})])}
var staticRenderFns = []

export { render, staticRenderFns }